import { Component, ViewChild, ElementRef, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { BillBatchService } from "app/open-api/api/billBatch.service";
import { BillService } from 'app/open-api';
import { ColumnMode, SelectionType } from "@swimlane/ngx-datatable";
import { environment } from "environments/environment";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from 'ngx-spinner';
import { CSVBillRQ } from "app/open-api/model/csvBillRQ";
import { CSVBillRP, SenderBillModel, CustomerBillModel, IdCode } from "app/open-api/model/csvBillRP";
import { TemporaryBillRQ } from "app/open-api/model/temporaryBillRQ";
import { ProccessTemporaryBills, ProccessSingleTemporaryBill } from "app/open-api/model/proccessTemporaryBills";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import Swal from 'sweetalert2';
import { LoadExternalOrdersRQ } from "app/open-api/model/LoadExternalOrdersRQ";
import { LoadExternalShimpmentRQ, LoadExternalShimpmentRP, Shimpment, LoadExternalOperation, InternarOrder, Order, ReceiverModel, SenderModel,OrderId, LoadExternalOrdersRP } from "app/open-api/model/LoadExternalOrdersRP";
import { BillOperationRP, GetBillOperationsRP } from "app/open-api/model/billOperation";
import { NgbDateStruct, NgbDatepicker, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadExternalOperationsModalComponent } from './../../shared/components/load-external-operations-modal/load-external-operations-modal.component';
import { AuthService } from '../../authentication/services/auth.service';
import { GetBillBatchRP } from '../../open-api/model/getBillBatchRP';
import {ExternalSearchModalComponent} from "./../../shared/components/external-search-modal/external-search-modal.component";

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss']
})
export class OrdersComponent implements OnInit {
  public basicSelectedOption: any = 5;
  loadOperation: LoadExternalOperation = {}
  shipments: Shimpment[] = [];
  orders: InternarOrder[] = [];
  searchOrders: InternarOrder[] = [];
  selected = [];
  public SelectionType = SelectionType;
  selectedOrders: InternarOrder[] = [];
  selectedOrder: InternarOrder;
  public ColumnMode = ColumnMode;
  canCheck = false;
  filter: LoadExternalShimpmentRQ = {};
  

  constructor(
    private billService: BillService,    
    private modalService: NgbModal,
    private spinner: NgxSpinnerService) { }

  ngOnInit() {
    
  }

  onActivate(event) {
    //console.log('Activate Event', event);
  }

  onSelect({ selected }) {
    this.selectedOrders = selected as InternarOrder[];
    this.selectedOrder = this.selectedOrders[this.selectedOrders.length - 1];
  }

  FilterUpdate(event) {    
    const count = 6;
    if(this.searchOrders.length > 0){     
      let keys = ["code","senderCellPhone", "senderFullName","serviceCode","totalWeight","dateCreated"]
      
      if (event && event !== "") {
        this.orders = this.searchOrders.filter((item) => {
          // iterate through each row's column data
          for (let i = 0; i < 6; i++) {
            // check for a match            
            if (
              (item[keys[i]] &&
                item[keys[i]]
                  .toString()
                  .toLowerCase()
                  .indexOf(event.toLowerCase().trim()) !== -1) ||
              !event.toLowerCase()
            ) {
              // found match, return true to add to result set
              return true;
            }
          }
        });
        //console.log('resultado', this.bills)
        //this.bills = this.searchBills.filter(x => x.code.toLowerCase().indexOf(event.toLowerCase()) > -1);
      } else {
        this.orders = this.searchOrders;
      }
    }
    // get the key names of each column in the dataset
    
    //this.searched = true;
  }

  FetchShipments(){   
    this.filter = {};
    this.shipments = []; 
    const refModal = this.modalService.open(ExternalSearchModalComponent, {
      windowClass: "modal",
      size: "lg",
    });
    refModal.result.then((result) => {
      if(result){
        this.spinner.show();
      this.filter = (result.filter as LoadExternalShimpmentRQ);
      const param: LoadExternalShimpmentRQ = this.filter;      
      this.billService.apiGetExternalShipmentsPost(param).subscribe(
        (response) => {          
          if (response.status == 200) {            
            this.shipments = response.shipments;
            this.spinner.hide();            
          }
          else {            
            Swal.fire({
              title: 'Resultado de la carga de envíos',
              text: response.text,
              icon: 'error',
              showConfirmButton: false,
              timer: 2000,              
              position: 'top-end'
            });
            this.spinner.hide();
          } 
          
        },
        (error) => {
          console.warn(error);
          this.spinner.hide();
        }
      );
      }
      
    })    
  }

  OpenHistoryModal() {
    const modalRef = this.modalService.open(LoadExternalOperationsModalComponent, {
      windowClass: 'modal',
      size: 'lg'
    });   
    modalRef.result.then(result => {
     // this.FetchModels();
    });
  }

  RemoveShipment(shipments, idShipment){
    const index = shipments.findIndex(
      (r) => r.shipmentNumber === idShipment
    );
   // console.log(shipments, idShipment, index)
    if (index !== -1) {
      shipments.splice(index, 1);
    }
    return shipments;
  }

  async ConfirmProcessAsAdmin(billCode: string){
    
    const swal = Swal.fire({
      title: `¿Está seguro que desea procesar el envío no ${billCode}.?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Procesar",
      cancelButtonText: "Cancelar",
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-danger",
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        this.spinner.show();
        let request : any = {
          shipmentNumer: +billCode
        }
        await this.billService.apiProccessExternOrdersPost(request).toPromise()
        .then(response => {          
            if (response) {              
              this.loadOperation = {};
              this.orders = [];
              //this.shipments = [];              
              Swal.fire({
                title: 'Resumen de procesamiento de envíos',
                text: `Fueron procesadas en total ${response.totalRecords} órdenes. \n ${response.totalSuccess} satisfactoriamente y  ${response.totalErrors} con errores`,
                icon: 'success',
                showConfirmButton: false,
                timer: 2000,                
                position: 'top-end'
              });             
              //let index = this.shipments.findIndex(d => d.shipmentId === response.shipmentId); //find index in your array
              let temp: Shimpment[] = [];
              temp = Object.assign([], this.shipments);
              //[temp] = [{...this.shipments}];
              //this.shipments = [];
              this.shipments = this.RemoveShipment(temp, response.shipmentId);
              this.spinner.hide();               
            }
          },(error) => {
            console.warn(error);
            this.spinner.hide();
          })        
      }
    });
  }

  get alloperations(): Shimpment[] {     
    return this.shipments.length > 0 ? this.shipments : [];   
  }  

  FetchModels() {
    this.spinner.show();
    const param: LoadExternalOrdersRQ = {
      
    };

    this.billService.apiGetExternOrdersPost(param).subscribe(
      (response) => {
        if (response) {
          
          this.loadOperation = (response as LoadExternalOrdersRP).operation;
          this.canCheck = this.loadOperation.totalSuccess > 0

          this.loadOperation.orders.forEach((item) => {
            let now: InternarOrder = this.getInternalOrder(item);
            this.searchOrders = this.orders = this.orders.concat(now);
          });
          
        }

        this.spinner.hide();
      },
      (error) => {
        console.warn(error);
        this.spinner.hide();
      }
    );
  }

  async ProccessOrders(){
    this.spinner.show();

    let request : any = {
      idOperation: this.loadOperation.id
    }

    const orders = await this.billService.apiProccessExternOrdersPost(request).toPromise().then(res => {
      this.loadOperation = {};
      this.orders = [];
      Swal.fire({
        title: 'Ordenes procesadas con exito',
        text: `Fueron procesadas ${res.totalSuccess} ordenes`,
        icon: 'success',
        showConfirmButton: false,
        timer: 2000,
        
        position: 'top-end'
      });
      this.spinner.hide();      
    }, error => {
      Swal.fire({
        title: 'Error!. ' + error,
        icon: 'error',
        showConfirmButton: false,
        timer: 2000,
        position: 'top-end'
      });
      this.spinner.hide();
    });
    this.spinner.hide();
    /*subscribe(
      (response) => {
        console.log(response);
        if (response) {
          
          
          console.log(response);
        }

        this.spinner.hide();
      },
      (error) => {
        console.warn(error);
        this.spinner.hide();
      }
    );*/

  }

  

  public CheckIfIsValid(codeSeek: OrderId): boolean {      
    let result = this.orders.find(({ id }) => id.orderId === codeSeek.orderId);    
    if (result !== null && result !== undefined) {      
      return result.isValid;
    }
    return true;
  }

  getReceiverModel(order: Order): ReceiverModel{
    let ret: ReceiverModel = {
      //receiverCellPhone: order.receiverCellPhone,
      //receiverEmail: order.receiverEmail,
      //receiverFirstName: order.receiverFirstName,
      //receiverFullName: order.receiverFullName,
      //receiverIdentification: order.receiverIdentification,
      //receiverLastName: order.receiverLastName,
      //receiverMiddleName: order.receiverMiddleName
    };

    return ret;
  }

  getSenderModel(order: Order): SenderModel{

    let ret: SenderModel = {
      senderCellPhone: order.senderCellPhone,
      //senderCellPhoneFormatted: order.senderCellPhoneFormatted,
      //senderEmail: order.senderEmail,
     // senderFirstName: order.senderFirstName,
      senderFullName: order.senderFullName,
      //senderIdentification: order.senderIdentification,
      //senderLastName: order.senderLastName,
      //senderMiddleName: order.senderMiddleName
    };
    
    return ret;
  }
  
  getOrderId(order: Order): OrderId {
    let ret: OrderId = {
      code: order.code,
      id: order.id,
      orderId: order.orderId
    };
    return ret;
  }

  getInternalOrder(order: Order): InternarOrder{    

    let ret: InternarOrder = {
      senderCellPhone: order.senderCellPhone,
      senderFullName: order.senderFullName,
      code: order.code,
      id: this.getOrderId(order), 
      serviceCode: order.serviceCode,
      senderModel: this.getSenderModel(order),      
      productsCode: order.productsCode,
      productsServiceCode: order.productsServiceCode,
      totalWeight: order.totalWeight,          
      dateCreated: order.dateCreated,
      dateUpdated: order.dateUpdated,
      priority: order.priority,      
      statusCode: order.statusCode,      
      totalProducts: order.totalProducts,       
      receiverModel: this.getReceiverModel(order), 
      isValid: order.isValid
    };
    return ret;
  }

  Back(): void {
    /*if (this.currentStep == 1 || this.currentStep == 3) this._location.back();
    else {
      this.resetSearch();
      this.currentStep = 1;
      this.selectedBills = [];
      this.bills = [];
      this.alreadyRegisteredBillsMsg = "";
      this.canCheck = false;
      //this.FetchModels();*/
    }
}


